<template>
  <div class="list row">
    <div class="col-md-8 mr-4">
      <div class="input-group mb-3">
        <input type="text" v-validate="'required|min:1|max:45'" class="form-control mr-2" placeholder="Search by surname" v-model="surname"/>
        <input type="text" v-validate="'required|min:9|max:9'" class="form-control mr-2" placeholder="Search by network ID" v-model="networkId"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="page = 1; retrieveMembers();"><font-awesome-icon icon="search" /> Search</button>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <button class="btn btn-primary" @click="newMember"><font-awesome-icon icon="plus" /> Add Member</button>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-8">
      <h4><font-awesome-icon icon="table" /> Members List</h4>
      <table class="gridview">
        <tr>
          <th>S/N</th><th>Network ID</th><th>Surname</th><th>First Name</th><th>Upline</th><th>Level</th>
        </tr>
        <tr class="" :class="{ active: index== currentIndex }" v-for="(member, index) in members" :key="member.id" @click="setActiveMember(member, index), toggleClass(this,'selected')">
          <td>{{ index+1 }}</td><td>{{ member.network_member_id }}</td><td>{{ member.surname }}</td>
          <td>{{ member.first_name }}</td><td>{{ member.upline }}</td><td>{{ member.level }}</td>
        </tr>
      </table>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
      <!--<table class="table table-borderless" style="float:right;">
        <tr>
          <td style="float:right;">
            <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
          </td>
          <td style="float:right;">Items per Page:
            <select v-model="pageSize" @change="handlePageSizeChange($event)">
              <option v-for="size in pageSizes" :key="size" :value="size">
                {{ size }}
              </option>
            </select>
          </td>
        </tr>
      </table>-->
    </div>
    <div class="col-md-4">
      <div v-if="currentMember">
        <h4><font-awesome-icon icon="info-circle" /> Member Details 
          <!--<a class="m-3 btn btn-sm btn-warning" :href="'/members/viewtree/' + currentMember.id"><font-awesome-icon icon="tree" /> View Tree </a>-->
          <router-link :to="{ path: '/members/viewtree/'+ currentMember.id}" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="tree" /> View Tree </router-link>
        </h4>
        <table class="table">
        <tr>
          <td><strong>Network Id:</strong></td><td> {{ currentMember.network_member_id }}</td>
        </tr>
        <tr>
          <td><strong>Surname:</strong></td><td> {{ currentMember.surname }}</td>
        </tr>
        <tr>
          <td><strong>First Name:</strong></td><td> {{ currentMember.first_name }}</td>
        </tr>
        <tr>
          <td><strong>Middle Name:</strong></td><td> {{ currentMember.middle_name }}</td>
        </tr>
        <tr>
          <td><strong>Gender:</strong></td><td> {{ currentMember.gender }}</td>
        </tr>
        <tr>
          <td><strong>Address:</strong></td><td> {{ currentMember.address }}</td>
        </tr>
        <tr>
          <td><strong>Country:</strong></td><td> {{ currentMember.country }}</td>
        </tr>
        <tr>
          <td><strong>State:</strong></td><td> {{ currentMember.state }}</td>
        </tr>
        <tr>
          <td><strong>Phone No.:</strong></td><td> {{ currentMember.phone_number }}</td>
        </tr>
        <tr>
          <td><strong>Email:</strong></td><td> {{ currentMember.email }}</td>
        </tr>
        <tr>
          <td><strong>Sponsor:</strong></td><td> {{ currentMember.sponsor }}</td>
        </tr>
        <tr>
          <td><strong>Level:</strong></td><td> {{ currentMember.level }}</td>
        </tr>
        <tr>
          <td><strong>Joined Date:</strong></td><td> {{ currentMember.joined_date | moment("dddd, MMMM Do YYYY") }}</td>
        </tr>
        <tr>
          <td><strong>Bank:</strong></td><td> {{ currentMember.bank }}</td>
        </tr>
        <tr>
          <td><strong>Account No.:</strong></td><td> {{ currentMember.account_number}}</td>
        </tr>
        <tr>
          <td><strong>Account Name:</strong></td><td> {{ currentMember.account_name }}</td>
        </tr>
        </table>
        <!--
        <a class="m-3 btn btn-sm btn-warning" :href="'/members/' + currentMember.id"><font-awesome-icon icon="edit" /> Edit </a>
        <a class="m-3 btn btn-sm btn-warning" :href="'/members/viewtree/' + currentMember.id"><font-awesome-icon icon="tree" /> View Tree </a>
        <a v-if="superAdmin" class="m-3 btn btn-sm btn-warning" :href="'/movemember/' + currentMember.id"><font-awesome-icon icon="pencil-alt" /> Move Member </a>-->
        <router-link :to="{ path: '/members/' + currentMember.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="edit" /> Edit </router-link>
        <router-link :to="{ path: '/members/viewtree/' + currentMember.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="tree" /> View Tree </router-link>
        <router-link v-if="superAdmin" :to="{ path: '/movemember/' + currentMember.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="pencil-alt" /> Move Member </router-link>
      </div>
      <div v-else>
        <br />
        <p>Please click on a Member...</p>
      </div>
    </div>
  </div>
</template>

<script>
import MemberService from "../services/member.service";

export default {
  name: "members-list",
  data() {
    return {
      members: [],
      currentMember: null,
      currentIndex: 0,
      surname: "",
      networkId: "",
      page: 1,
      count: 0,
      pageSize: 100,
      pageSizes: [10, 15, 20, 25, 50, 100],
      totalPages: 0,
      loading: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    superAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_SUPERADMIN');
      }

      return false;
    }

  },
  methods: {
    /*retrieveMembersOld() {
      this.loading = true;
      MemberService.getAll()
        .then(response => {
          this.members = response.data;
          //console.log(response.data);
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },*/
    
    getRequestParams(surname, page, pageSize) {
      let params = {};

      if (surname) {
        params["surname"] = surname;
      }

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },

    retrieveMembers() {
      this.loading = true;
      /*const params = this.getRequestParams(
        this.surname,
        this.page,
        this.pageSize
      );*/
      if (this.page) {
        this.page = this.page - 1;
      }
      if (this.networkId) {
        this.surname = "";
        MemberService.getTotalMembersByMemberId(this.networkId)
          .then(response => {
            this.count = response.data;
            //console.log(response.data);
            MemberService.getAllMembersByMemId(this.networkId, this.page, this.pageSize)
              .then(response => {
                this.members = response.data;
                this.loading = false;
              })
              .catch(e => {
                console.log(e);
              });
          })
          .catch(e => {
            console.log(e);
          });  
      }
      if (this.surname) {
        this.networkId = "";
        MemberService.getTotalMembersBySurname(this.surname)
          .then(response => {
            this.count = response.data;
            //console.log(response.data);
            MemberService.getAllMembersPageable(this.surname, this.page, this.pageSize)
              .then(response => {
                this.members = response.data;
                this.loading = false;
              })
              .catch(e => {
                console.log(e);
              });
          })
          .catch(e => {
            console.log(e);
          });
      }
      if (!this.surname && !this.networkId){
        MemberService.getTotalMembers()
          .then(response => {
            this.count = response.data;
            //console.log(response.data);
            MemberService.getAllMembersPageable(this.surname, this.page, this.pageSize)
              .then(response => {
                this.members = response.data;
                this.loading = false;
                this.surname = "";
              })
              .catch(e => {
                console.log(e);
              });
          })
          .catch(e => {
            console.log(e);
          });
      }
      /*MemberService.getAllMembersPageable(this.surname, this.page, this.pageSize)
        .then(response => {
          this.members = response.data;
          //if (this.count % this.pageSize == 0) {
            //this.totalPages = Math.ceil(this.count / this.pageSize);
          //} else {
            //this.totalPages = Math.ceil((this.count / this.pageSize) + 1);
          //}
          this.loading = false;
          this.surname = "";
        })
        .catch(e => {
          console.log(e);
        });*/
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveMembers();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveMembers();
    },

    /*prevPage() {
      this.page--;
      window.scrollTo({top: 0, behavior: 'smooth'});
    },

    nextPage() {
      if (this.page == this.lastPage - 1) {
        this.apiPage++;
        this.retrieveMembers();
      }
      this.page++;
      window.scrollTo({top: 0, behavior: 'smooth'});
    },*/

    refreshList() {
      this.retrieveMembers();
      this.currentMember = null;
      this.currentIndex = -1;
    },

    setActiveMember(member, index) {
      this.currentMember = member;
      this.currentIndex = index;
    },

    removeAllMembers() {
      MemberService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    searchBySurname() {
      this.loading = true;
      MemberService.getBySurname(this.surname)
        .then(response => {
          this.members = response.data;
          this.loading = false;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    newMember() {
      this.$router.push('/addmember');
    },

    toggleClass(el, className) {
      if (el.className.indexOf(className) >= 0) {
         el.className = el.className.replace(className,"");
      }
      else {
        el.className  += className;
      }
    }

  },
  mounted() {
    this.retrieveMembers();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}

.gridview
{
    border-collapse: collapse;
    margin: 0px 10px 10px 0;
    /*box-shadow: 3px 3px 4px #bbb;*/
    width: 100%;
    max-width: 100%;    
}

.gridview, .gridview td,  .gridview th
{
    border:  1px solid #cccccc;
}

.gridview th
{
    text-align: left;
    /*font-size: 1.2em;*/
    font-weight: normal;
    color: #F9F9F9;    
    background: #232324;
}

.gridview th a, .gridview th a:link, .gridview th a:visited, .gridview th a:active
{
    color: #fff;
    text-decoration: none;
}

.gridview th a:hover
{
    text-decoration: underline;
}

.gridview tr
{
    background: #fff;
}

.gridview tr:nth-child(odd) 
{
    background-color: #fff;
}
.gridview tr:nth-child(even) 
{
    background-color: #fff;
}

.gridview td 
{
    font-weight: normal;    
    text-align: left;
    vertical-align: top;
}

.gridview td, table th
{
    padding: 5px 8px;
}

.gridview tfoot td
{
    background-color: #fff;
}

.gridview tfoot td .page
{
    color: #000000;
    font-weight: bold;
}

.gridview tr.subfoot, .gridview tr.subfoot td
{
    background-color: #1E90FF;
}

.gridview tr:hover td, .gridview tbody tr:hover td
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview .selected, .gridview tr td .selected
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview tr.active td, .gridview tbody tr.active td
{
    background-color: #1E90FF;
    color: #fff;
}

@keyframes spinner {
    to {
        transform: rotate(360deg);
    }
}

.fa-spinner {
    animation: spinner 1s linear infinite;
}

a:hover {
    cursor: pointer;
}
</style>